import Overview from './overview.vue';
import Full from '@/rebuild/materials/shared/quarterly_performance/FullIndex.vue';
import MobOverview from '@/rebuild/materials/shared/quarterly_performance/mobile/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/quarterly_performance/mobile/MobFull.vue';
export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 